<template>
    <div>
        <b-card class="card-news-form" header-tag="header" footer-tag="footer">
        <alert-success :redirectName="'101categories-home'" :show="successMessage != ''"> {{ successMessage }} </alert-success>
        <b-alert class="text-center" :show="errorMessage != ''" variant="danger"> {{ errorMessage }} </b-alert>
        <!-- for loading page -->
        <app-loading :className="isLoading ? 'loading' : ''"></app-loading>
        <div slot="header">
        <i class="fa fa-list-ul" aria-hidden="true"></i>
            Cagetory Form
        <div class="card-header-actions">
            <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
            <small class="text-muted">docs</small>
            </a>
        </div>
        </div>
        <div>

          <b-row>
            <b-col sm="12">
            <!-- Icon -->
              <b-form-group>
                <b-row>
                <b-col cols="12" sm="2" class="text-center">
                  <img @click="modalShow = true, previewModal = previewIcon" class="icon" :src="previewIcon" alt="icon">
                </b-col>
                <b-col cols="12" sm="10" class="margin-top-20">
                <b-input-group>
                <div class="custom-file">
                    <input type="file" class="custom-file-input form-upload" @change="changeIcon">
                    <label class="custom-file-label"> {{ form.icon.name || 'choose icon maximum 350x350' }} </label>
                </div>
                <b-button variant="outline-secondary" @click="previewIcon = '/images/101/thumbnail.png'; form.icon = {}; form.defaultIcon = true">
                  Set Default
                </b-button>
                </b-input-group>
                </b-col>
                </b-row>
              </b-form-group>

               <!-- Name -->
              <b-form-group>
                <label>Name</label>
                <b-input-group>
                    <b-input :state="feedback(fieldErrors.name)" v-model="form.name" placeholder="please enter name category"></b-input>
                </b-input-group>
              </b-form-group>

            </b-col>
          </b-row>
        </div>
        <div slot="footer">
          <b-button @click="$router.go(-1)" class="mr-2" size="sm" variant="secondary">
            <i class="fa fa-angle-left" aria-hidden="true"></i>
            Back
          </b-button>
          <b-button :disabled="!isActive" @click="save" class="mr-2" type="submit" size="sm" variant="primary">
            <i class="fa fa-dot-circle-o"></i>
            Save
          </b-button>
          <b-button :disabled="!isActive" v-b-modal.confirmDelete v-if="$route.params.id" type="reset" size="sm" variant="danger">
            <i class="fa fa-ban"></i>
            Delete
          </b-button>
          <alert-confirm
            :id="'confirmDelete'"
            @confirm="confirmDelete">
            confirm to delete ?
          </alert-confirm>
          <b-modal centered hide-header hide-footer v-model="modalShow" body-class="text-center">
                <b-img fluid :src="previewModal" alt="image"></b-img>
          </b-modal>
        </div>
    </b-card>
    </div>
</template>

<script>
import AlertSuccess from '../../components/alert/AlertSuccess';
import AlertConfirm from '../../components/alert/AlertConfirm';
import Loading from '../../components/Loading';

export default {
  data () {
    return {
      isLoading: '',
      successMessage: '',
      errorMessage: '',
      isActive: true,
      form: {
        icon: {},
        name: '',
        defaultIcon: true
      },
      previewIcon: '/images/101/thumbnail.png',
      fieldErrors: {},
      zones: [],
      categories: [],
      floors: [],
      tiers: [],
      isLoadFinish: [],
      modalShow: false,
      previewModal: ''
    };
  },
  methods: {
    confirmDelete () {
      this.axios.delete(process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdc/base/categories/' + this.$route.params.id)
        .then(response => {
          this.successMessage = 'delete category finish!';
        })
        .catch(error => {
          this.isLoading = false;
          this.isActive = true;
          this.handleError(error);
        });
    },
    save () {
      const id = this.$route.params.id;
      this.isLoading = true;
      this.isActive = false;
      this.fieldErrors = {};
      this.errorMessage = '';
      const formData = new FormData();
      formData.append('name', this.form.name);
      formData.append('icon', this.form.icon);
      formData.append('defaultIcon', this.form.defaultIcon);
      if (id) { // update
        this.axios.patch(process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdc/base/categories/' + id, formData)
          .then(response => {
            this.isLoading = false;
            this.successMessage = 'update category finish!';
          })
          .catch(error => {
            this.isLoading = false;
            this.isActive = true;
            this.handleError(error);
          });
      } else { // create
        this.axios.post(process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdc/base/categories', formData)
          .then(response => {
            this.isLoading = false;
            this.successMessage = 'create category finish!';
          })
          .catch(error => {
            this.isLoading = false;
            this.isActive = true;
            this.handleError(error);
          });
      }
    },
    changeIcon (e) {
      const files = e.target.files || e.dataTransfer.files;
      this.form.icon = files[0];
      this.form.defaultIcon = false;
      this.previewIcon = URL.createObjectURL(this.form.icon);
    },
    getData () {
      this.setDefault();
      const id = this.$route.params.id;
      if (id) {
        this.axios.get(process.env.VUE_APP_URL_MQDC_API + '/categories', { headers: {
          Accept: 'application/json'
        } })
          .then(response => {
            const data = response.data.data;
            const category = data.find(c => c.id === id);
            if (category) {
              this.previewIcon = category.icon || this.previewIcon;
              this.form = {
                icon: {},
                name: category.name
              };
            }
          })
          .catch(error => {
            this.handleError(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    handleError (error) {
      this.fieldErrors = {};
      this.errorMessage = error.message;
      if (error.response) {
        this.errorMessage = error.response.data.message;
        const data = error.response.data.data;
        console.log(data);
        this.setFieldErrors(data);
      }
      this.isLoading = false;
    },
    setFieldErrors (fields) {
      if (fields) {
        for (const field of fields) {
          this.fieldErrors[field.param] = { message: field.msg, isCorrect: false };
        }
      }
    },
    setDefault () {
      this.form = {
        icon: {},
        name: '',
        defaultIcon: true
      };
      this.previewIcon = '/images/101/thumbnail.png';
      this.errorMessage = '';
      this.fieldErrors = {};
    }
  },
  components: {
    AlertSuccess,
    AlertConfirm,
    'app-loading': Loading
  },
  computed: {
    feedback () {
      return data => {
        if (!data) {
          return null;
        } else {
          return data.isCorrect;
        }
      };
    }
  },
  mounted () {
    this.getData();
  },
  watch: {
    '$route' (to, from) {
      this.getData();
    }
  }
};
</script>

<style scoped>
    .icon{
      max-height: 75px;
      max-width: 100px;
      -webkit-box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
      -moz-box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
      box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
      margin-bottom: 5px;
    }
    .icon:hover{
        cursor: pointer;
    }
    .text-center{
        text-align: center;
    }
    .margin-top-20{
        margin-top: 20px;
    }
    .form-upload:hover {
        cursor: pointer;
    }
    .custom-file-label{
        overflow: hidden;
        white-space: nowrap;
    }
    .fix-font{
        margin-top: 8px;
        margin-left: 10px;
        margin-right: 10px;
    }
    .autocomplete{
        width: 60px;
        text-align: center;
    }
    .autocomplete__entry{
        text-align: center;
    }
    .autocomplete__entry:hover{
        cursor: pointer;
    }
    .text-center{
        text-align: center;
    }
</style>

<style>
  .select-validate-fail .vs__search::placeholder,
  .select-validate-fail .vs__dropdown-toggle,
  .select-validate-fail .vs__dropdown-menu {
    border: 1px solid #f86c6b;
  }
</style>
